<template>
  <div class="benefit-list-popup-component">
    <ym-popup class="benefit-list-popup"
              v-model="visible"
              round
              position="bottom"
              get-container="body"
    >
      <div class="popup-header ym-hairline--bottom">
        <h3 class="title">
          <ym-icon v-if="showBack"
                   class="icon-back"
                   name="back"
                   @click.native="handleBack"
          />
          {{ title }}
        </h3>
      </div>
      <ul class="benefit-list">
        <li class="benefit-item"
            v-for="item in list"
            :key="item.id"
            @click="handleChoseBenefit(item)"
        >
          <div class="popup-item">
          <span class="name ym-line-ellipsis">
            <span v-if="item.save > 0">省{{ item.save }}元：</span>
            {{ item.name }}
          </span>
            <ym-icon class="icon-check"
                     :class="[ item.isChecked ? 'is-checked' : '']"
                     :name="item.isChecked ? 'round-check-fill' : 'round'"
            />
          </div>
          <div v-if="item.type === 'useCoupon'"
               class="input-coupon"
               v-show="showInputCoupon"
          >
            <ym-field class="input"
                      v-model="couponCode"
                      v-focus.lazy="showInputCoupon"
                      model="rectangle-box"
                      placeholder="输入优惠码"
                      @input="handleInput"
            ></ym-field>
            <ym-button class="use-coupon-btn"
                       type="primary"
                       size="small"
                       plain
                       :disabled="useCouponBtnDisabled"
                       v-show="showUseBtn"
                       @click="handleUseCoupon"
            >
              使用
            </ym-button>
            <span class="coupon-status"
                  :class="[couponUsable ? 'active' : 'danger']"
                  v-show="!showUseBtn"
            >{{ couponStatusString }}</span>
          </div>
        </li>
      </ul>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup, Field, Button } from '@ymba/ym-ui';
  import { checkCoupon } from '@/services/order';
  import validator from '@/utils/validator';
  import { sliceDiscountId, sliceCouponId } from '@/utils';

  export default {
    name: 'BenefitListPopup',
    components: {
      'ym-popup': Popup,
      'ym-field': Field,
      'ym-button': Button,
    },
    data() {
      return {
        list: [],
        visible: false,
        couponCode: '',
        showInputCoupon: false,
        showUseBtn: true,
        couponUsable: false,
        disabledUseBtn: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      benefits: {
        type: Array,
        required: true,
      },
      choose: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      targetId: {
        type: Number,
        required: true,
      },
      targetType: {
        type: String,
        required: true,
      },
      showBack: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        default: '选择优惠方式',
      },
    },
    computed: {
      couponStatusString() {
        return this.couponUsable ? '优惠码可用' : '优惠码无效';
      },
      useCouponBtnDisabled() {
        return validator.isEmpty(this.couponCode) || this.disabledUseBtn;
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
      choose() {
        this.generateList(this.list);
      },
      benefits(val) {
        this.generateList(val);
      },
    },
    methods: {
      generateList(data) {
        const { choose } = this;
        const { uniqueId: chooseId } = choose || {};
        this.list = data.map((item) => {
          const { uniqueId } = item;
          if (uniqueId === chooseId) {
            this.handleChoseBenefit(item, false);
          }
          return item;
        });
      },
      handleBack() {
        this.visible = false;
        this.$emit('back');
      },
      choseBenefitItem(benefit) {
        if (benefit.isChecked) return;
        this.list.forEach((item) => {
          if (item.isChecked) {
            item.isChecked = !item.isChecked;
          }
        });
        benefit.isChecked = true;
      },
      toggleChose(benefit, close = true) {
        if (close) {
          const {
            uniqueId = '',
            save = '',
            name = '',
          } = benefit;
          const discountIds = sliceDiscountId(uniqueId);
          const couponIds = sliceCouponId(uniqueId);
          this.$emit('chose', {
            discountIds,
            couponIds,
            name,
            save,
            uniqueId,
          });
          this.visible = false;
        }
      },
      handleChoseBenefit(benefit, close = true) {
        this.choseBenefitItem(benefit);
        // 选择使用优惠码
        if (benefit.type === 'useCoupon') {
          this.showInputCoupon = true;
          this.showUseBtn = true;
          return;
        }
        // 非使用优惠码时隐藏优惠码输入框
        if (this.showInputCoupon) this.showInputCoupon = false;
        this.toggleChose(benefit, close);
      },
      async handleUseCoupon() {
        this.disabledUseBtn = true;
        const { targetId, targetType, couponCode } = this;
        try {
          const data = await checkCoupon({
            targetId,
            targetType,
            couponCode,
          });
          const { usable, uniqueId } = data;
          this.couponUsable = usable;
          if (!usable) {
            this.showUseBtn = false;
            return;
          }
          this.toggleChose({
            uniqueId,
            name: `优惠码：${couponCode}`,
          });
          this.disabledUseBtn = false;
        } catch (e) {
          this.disabledUseBtn = false;
        }
      },
      handleInput() {
        this.showUseBtn = true;
      },
    },
    created() {
      this.generateList(this.benefits);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .benefit-list-popup {
    min-height: 482px;
    line-height: 1;
  }

  .popup-header {
    padding: @size-base;
    text-align: center;
  }

  .title {
    margin: 0;
    font-size: @font-size-large;
    font-weight: @font-weight-primary;
    color: @color-text-base;
    position: relative;
  }

  .icon-back {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    color: @color-text-base;
  }

  .benefit-list {
    margin: 0;
    padding: 0 @size-base;
    list-style: none;
    max-height: 712px;
    overflow-y: scroll;
  }

  .popup-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 94px;
    overflow: hidden;
  }

  .name {
    flex: 1;
    text-align: left;
    font-size: @font-size-medium;
    color: @color-text-light;
  }

  .icon-check {
    font-size: 40px;
    flex-shrink: 0;
    margin-left: @size-extra-small;
    color: @color-text-lighter;

    &.is-checked {
      color: @color-primary;
    }
  }

  @input-coupon-height: 60px;
  .input-coupon {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: @size-base;
  }

  .input {
    flex: 1;
    min-height: auto;
    height: @input-coupon-height;
    font-size: @font-size-base;
    border: @border-base;
    border-radius: @border-radius-base;
    box-sizing: border-box;

    /deep/ .mint-field-core {
      padding: @size-extra-small;
      box-sizing: border-box;
    }
  }

  .use-coupon-btn {
    width: 120px;
    flex-shrink: 0;
    margin-left: @size-base;
    height: @input-coupon-height;
  }

  .coupon-status {
    flex-shrink: 0;
    color: @color-text-light;
    margin-left: @size-base;

    &.primary {
      color: @color-primary;
    }

    &.danger {
      color: @color-text-highlight;
    }
  }

</style>
